// Three sources hand us resumes: the kula_contact_resumes block payload
// (ResumeFile, already camelCased by the block mapper), the /candidates/:id
// /profile response (ResumePayload, raw snake_case), and the host ATS
// /contacts/:id/resumes response (AtsResumeFile, raw snake_case). All collapse
// onto ResumeAttachment so ResumeSection only knows one shape.

import type { ResumePayload } from '../../../api/candidates';
import type { ResumeFile } from '../../../types';
import type { ResumeAttachment } from './ResumeSection.types';

const DEFAULT_FILE_NAME = 'Resume.pdf';
const DEFAULT_CONTENT_TYPE = 'application/pdf';

// A resume item from the host ATS GET /contacts/:id/resumes list.
export interface AtsResumeFile {
  id: number;
  file_name?: string;
  content_type?: string;
  url?: string;
}

export const fromResumeFiles = (files: ResumeFile[]): ResumeAttachment[] =>
  files
    .filter((f) => f.url)
    .map((f) => ({
      id: f.id,
      fileName: f.fileName || DEFAULT_FILE_NAME,
      contentType: f.contentType || DEFAULT_CONTENT_TYPE,
      url: f.url,
    }));

export const fromResumePayloads = (
  payloads: ResumePayload[]
): ResumeAttachment[] =>
  payloads
    .filter((p): p is ResumePayload & { url: string } => !!p.url)
    .map((p) => ({
      id: p.id,
      fileName: p.file_name || DEFAULT_FILE_NAME,
      contentType: p.content_type || DEFAULT_CONTENT_TYPE,
      url: p.url,
    }));

export const fromAtsResumes = (files: AtsResumeFile[]): ResumeAttachment[] =>
  files
    .filter((f): f is AtsResumeFile & { url: string } => !!f.url)
    .map((f) => ({
      id: f.id,
      fileName: f.file_name || DEFAULT_FILE_NAME,
      contentType: f.content_type || DEFAULT_CONTENT_TYPE,
      url: f.url,
    }));
